import React from "react";

interface IAdditionalServiceItemTitle {
  title: string;
}

export const AdditionalServiceItemTitle: React.FC<
  IAdditionalServiceItemTitle
> = ({ title }) => {
  return <h4 className="text-lg font-semibold leading-6">{title}</h4>;
};
